/* Importing Angular Core */
import { Injectable } from "@angular/core";
import { environment } from "app/environments/environment";
@Injectable()
export class Config {
  config = {
    endPoint: environment.ENDPOINT + "/api",
    s3endPoint: environment.ENDPOINT + "/api/s3",
    signalr: environment.ENDPOINT + "/signalr",
    maxUploadAtTime: 3,
  };

  /**
   * Returning Value According to Key and Provide
   * DefaultKey in case of missing
   * @param key
   * @param defaultKey
   */
  get(key, defaultKey = undefined) {
    if (!this.config[key]) return defaultKey;

    return this.config[key];
  }

  /**
   * Assign Key-Value to Config
   * @param key
   * @param value
   */
  set(key, value) {
    this.config[key] = value;
    return this;
  }
}
